import home from './home'
import product from './product'
import solution from './solution'
import technology from './technology'
import buy from './buy'
import smartApps from './smart-apps'
import cloudNative from './cloud-native'
import digitalThread from './digital-thread'
import edgeComputing from './edge-computing'
import twin from './twin'
import whyJWI from './why-jwi'
import history from './history'
import careers from './careers'
import industry from './industry'
import analytics from './analytics'
import iot from './iot'
import cloudPlatform from './cloud-platform'
import digitalPdm from './digital-pdm'
import digitalNpi from './digital-npi'
import digitalPpm from './digital-ppm'
import digitalMpm from './digital-mpm'
import digitalPqm from './digital-pqm'
import navigation from './navigation'
import deviceMate from './device-mate'
import productLine from './product-line'

const common = {
  website: 'JWI Software',
  // 头部导航
  home: 'HOME',
  login: 'LOGIN',
  contactUs: 'CONTACT US',
  products: 'PRODUCTS',
  platform: 'DIGITAL PLATFORM',
  jicCloud: 'Digital Thread Platform',
  devopsCloud: 'Cloud Platform',
  engineering: 'DIGITAL ENGINEERING',
  navigator: 'Design Navigator',
  pdm: 'Digital PDM',
  ppm: 'Digital PPM',
  mpm: 'Digital MPM',
  npi: 'Digital NPI',
  factory: 'DIGITAL FACTORY',
  pqm: 'Quality Cloud - PQM',
  deviceMate: 'Device Mate',
  productionLineEngine: 'Production Line Engine',
  solutions: 'SOLUTIONS',
  technology: 'TECHNOLOGY',
  cloudNative: 'Cloud Native',
  digitalThread: 'Real-Time Digital Thread',
  smartApps: 'Smart Applications',
  edgeComputing: 'Edge Computing',
  twin: 'Digital Twin',
  analytics: 'Advanced Analytics',
  iot: 'Industrial IoT',
  company: 'COMPANY',
  whyJwi: 'WHY JWI',
  history: 'HISTORY',
  careers: 'CAREERS',
  trybuy: 'TRY & BUY',
  jwisoftware: 'jwisoftware',
  btnCancel: 'Cancel',
  btnConfirm: 'Confirm'
}
export default Object.assign(home, product, solution, technology, buy, smartApps, cloudNative, digitalThread, edgeComputing, twin, whyJWI, history, careers, industry, analytics, iot, cloudPlatform, digitalPdm, digitalNpi, digitalPpm, digitalMpm, digitalPqm, navigation, deviceMate, productLine, common)
